// import React from 'react';
// import {Button, Form, Table} from 'react-bootstrap';
// import * as XLSX from 'xlsx';
//
// const DrawersTable = ({drawers, order, handleDrawerFieldChange}) => {
//     const drawerOptionsList = [
//         'A - Cutlery Insert',
//         'B - Utensil Insert',
//         'C - Cutlery/Utensil',
//         'D - Knife Insert',
//         'E - Spice Inser',
//         'F - Custom Dividers',
//         'G - Double Drawer',
//         'H1 - File Drawer - Front to Back',
//         'H2 - File Drawer - Side to Side',
//         'J - Shaped Sides',
//         'L - U-Shaped Drawer',
//         'M - Corner Drawer',
//         'N - Trash Pull-Out, Drawer',
//         'O - Trash Pull-Out Drawer',
//         'P - Bread Drawer',
//         'Q - Front Lip',
//     ];
//
//     const yesNoOptions = [
//         {value: 'Yes', label: 'Yes'},
//         {value: 'No', label: 'No'}
//     ];
//
//
//     // Function to convert a measurement string (e.g., "5-1/32") to a decimal value.
//     const convertMeasurementToDecimal = (measurement) => {
//         if (typeof measurement === 'number') return measurement;
//         if (typeof measurement === 'string') {
//             // Check for a fraction format like "5-1/32"
//             if (measurement.includes('-')) {
//                 const parts = measurement.split('-');
//                 if (parts.length === 2) {
//                     const whole = parseFloat(parts[0]);
//                     const fractionParts = parts[1].split('/');
//                     if (fractionParts.length === 2) {
//                         const numerator = parseFloat(fractionParts[0]);
//                         const denominator = parseFloat(fractionParts[1]);
//                         if (!isNaN(whole) && !isNaN(numerator) && !isNaN(denominator) && denominator !== 0) {
//                             return whole + numerator / denominator;
//                         }
//                     }
//                 }
//             }
//             // Fallback: attempt to parse a float from the string
//             const value = parseFloat(measurement);
//             if (!isNaN(value)) return value;
//         }
//         return measurement; // return as is if conversion isn't applicable
//     };
//
//     const handleExportExcel = () => {
//         const headers = [
//             'Quantity',
//             'Width',
//             'Height',
//             'Depth',
//             'Bottom',
//             'Notch & Bore',
//             'Finish',
//             'Drawer Options',
//             'Finish Front',
//             'Scoop',
//             'Include Glides'
//         ];
//
//         // Map each drawer into a row of data. The width, height, and depth are converted to decimal if necessary.
//         const data = drawers.map((drawer) => [
//             drawer.quantity,
//             convertMeasurementToDecimal(drawer.width),
//             convertMeasurementToDecimal(drawer.height),
//             convertMeasurementToDecimal(drawer.depth),
//             drawer.bottom || '1/4"',
//             drawer.notchAndBore || 'Yes',
//             drawer.finish || 'Yes',
//             drawer.drawerOptions || '',
//             drawer.finishFront || 'Yes',
//             drawer.scoop || 'No',
//             drawer.includeGlides || 'Yes'
//         ]);
//
//         // Create worksheet with headers and data
//         const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
//
//         // Set column widths based on header length
//         const colWidths = headers.map((header) => ({wch: Math.max(header.length, 12)}));
//         ws['!cols'] = colWidths;
//
//         // Create workbook and append the worksheet
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, 'Drawers');
//
//         // Generate and trigger the Excel file download
//         XLSX.writeFile(wb, `drawers_table_${new Date().toISOString().split('T')[0]}.xlsx`);
//     };
//
//     return (
//         <div>
//             <div className="mb-3">
//                 <Button variant="outline-primary" onClick={handleExportExcel} className="mb-2">
//                     Export to Excel
//                 </Button>
//             </div>
//             <Table responsive className="om-table">
//                 <thead>
//                 <tr>
//                     <th>Qty</th>
//                     <th>Width</th>
//                     <th>Height</th>
//                     <th>Depth</th>
//                     <th>Bottom</th>
//                     <th>Notch &amp; Bore</th>
//                     <th>Finish</th>
//                     <th>Drawer Options</th>
//                     <th>Finish Front</th>
//                     <th>Scoop</th>
//                     <th>Include Glides</th>
//                     <th>Gross</th>
//                     <th>Net Cost</th>
//                     <th>Net Profit</th>
//                 </tr>
//                 </thead>
//                 <tbody>
//                 {drawers.map((drawer, index) => (
//                     <tr key={index}>
//                         <td>{drawer.quantity}</td>
//                         <td>{drawer.width}</td>
//                         <td>{drawer.height}</td>
//                         <td>{drawer.depth}</td>
//                         <td>{drawer.bottom || '1/4"'}</td>
//                         <td>
//                             <Form.Select
//                                 value={drawer.notchAndBore || 'Yes'}
//                                 onChange={(e) => handleDrawerFieldChange(index, 'notchAndBore', e.target.value)}
//                             >
//                                 {yesNoOptions.map((option) => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </td>
//                         <td>
//                             <Form.Select
//                                 value={drawer.finish || 'Yes'}
//                                 onChange={(e) => handleDrawerFieldChange(index, 'finish', e.target.value)}
//                             >
//                                 {yesNoOptions.map((option) => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </td>
//                         <td>
//                             <Form.Select
//                                 value={drawer.drawerOptions || ''}
//                                 onChange={(e) => {
//                                     const selectedText = e.target.value;
//                                     handleDrawerFieldChange(index, 'drawerOptions', selectedText);
//                                 }}
//                             >
//                                 <option value="">Select</option>
//                                 {drawerOptionsList.map((option, idx) => {
//                                     const value = option.split('-')[0].trim();
//                                     return (
//                                         <option key={idx} value={value}>
//                                             {option}
//                                         </option>
//                                     );
//                                 })}
//                             </Form.Select>
//                         </td>
//                         <td>
//                             <Form.Select
//                                 value={drawer.finishFront || 'Yes'}
//                                 onChange={(e) => handleDrawerFieldChange(index, 'finishFront', e.target.value)}
//                             >
//                                 {yesNoOptions.map((option) => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </td>
//                         <td>
//                             <Form.Select
//                                 value={drawer.scoop || 'No'}
//                                 onChange={(e) => handleDrawerFieldChange(index, 'scoop', e.target.value)}
//                             >
//                                 {yesNoOptions.map((option) => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </td>
//                         <td>
//                             <Form.Select
//                                 value={drawer.includeGlides || 'Yes'}
//                                 onChange={(e) => handleDrawerFieldChange(index, 'includeGlides', e.target.value)}
//                             >
//                                 {yesNoOptions.map((option) => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </td>
//                         <td>{`$${drawer.totalPrice}` || ''}</td>
//                         <td>{`$${drawer.netCost.toFixed(2)}` || ''}</td>
//                         <td>{`$${drawer.netProfit.toFixed(2)}` || ''}</td>
//                     </tr>
//                 ))}
//                 </tbody>
//             </Table>
//         </div>
//     );
// };
//
// export default DrawersTable;


import React from 'react';
import {Button, Form, Table} from 'react-bootstrap';
import * as XLSX from 'xlsx';

const DrawersTable = ({drawers, order, handleDrawerFieldChange}) => {
    const drawerOptionsList = [
        'A - Cutlery Insert',
        'B - Utensil Insert',
        'C - Cutlery/Utensil',
        'D - Knife Insert',
        'E - Spice Inser',
        'F - Custom Dividers',
        'G - Double Drawer',
        'H1 - File Drawer - Front to Back',
        'H2 - File Drawer - Side to Side',
        'J - Shaped Sides',
        'L - U-Shaped Drawer',
        'M - Corner Drawer',
        'N - Trash Pull-Out, Drawer',
        'O - Trash Pull-Out Drawer',
        'P - Bread Drawer',
        'Q - Front Lip'
    ];

    const yesNoOptions = [
        {value: 'Yes', label: 'Yes'},
        {value: 'No', label: 'No'}
    ];

    // Function to convert a measurement string (e.g., "5-1/32") to a decimal value.
    const convertMeasurementToDecimal = (measurement) => {
        if (typeof measurement === 'number') return measurement;
        if (typeof measurement === 'string') {
            // Check for a fraction format like "5-1/32"
            if (measurement.includes('-')) {
                const parts = measurement.split('-');
                if (parts.length === 2) {
                    const whole = parseFloat(parts[0]);
                    const fractionParts = parts[1].split('/');
                    if (fractionParts.length === 2) {
                        const numerator = parseFloat(fractionParts[0]);
                        const denominator = parseFloat(fractionParts[1]);
                        if (!isNaN(whole) && !isNaN(numerator) && !isNaN(denominator) && denominator !== 0) {
                            return whole + numerator / denominator;
                        }
                    }
                }
            }
            // Fallback: attempt to parse a float from the string
            const value = parseFloat(measurement);
            if (!isNaN(value)) return value;
        }
        return measurement; // return as is if conversion isn't applicable
    };

    const handleExportExcel = () => {
        const headers = [
            'Quantity',
            'Width',
            'Height',
            'Depth',
            'Bottom',
            'Notch & Bore',
            'Finish',
            'Drawer Options',
            'Finish Front',
            'Scoop',
            'Include Glides'
        ];

        // Map each drawer into a row of data.
        const data = drawers.map((drawer) => {
            // Compute values based on the depth property.
            const depthStr = drawer.depth ? drawer.depth.toString() : '';
            const computedDrawerOptions = depthStr.endsWith('1/2') ? 'Q - Front Lip' : (drawer.drawerOptions || '');
            const computedFinishFront = depthStr.endsWith('1/2') ? 'Yes' : 'No';

            return [
                drawer.quantity,
                convertMeasurementToDecimal(drawer.width),
                convertMeasurementToDecimal(drawer.height),
                convertMeasurementToDecimal(drawer.depth),
                drawer.bottom || '1/4"',
                drawer.notchAndBore || 'Yes',
                drawer.finish || 'Yes',
                computedDrawerOptions,
                computedFinishFront,
                drawer.scoop || 'No',
                'Blum Tandem'
                // drawer.includeGlides || 'Yes'
            ];
        });

        // Create worksheet with headers and data
        const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);

        // Set column widths based on header length
        const colWidths = headers.map((header) => ({wch: Math.max(header.length, 12)}));
        ws['!cols'] = colWidths;

        // Create workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Drawers');

        // Generate and trigger the Excel file download
        XLSX.writeFile(wb, `drawers_table_${new Date().toISOString().split('T')[0]}.xlsx`);
    };

    return (
        <div>
            <div className="mb-3">
                <Button variant="outline-primary" onClick={handleExportExcel} className="mb-2">
                    Export to Excel
                </Button>
            </div>
            <Table responsive className="om-table">
                <thead>
                <tr>
                    <th>Qty</th>
                    <th>Width</th>
                    <th>Height</th>
                    <th>Depth</th>
                    <th>Bottom</th>
                    <th>Notch &amp; Bore</th>
                    <th>Finish</th>
                    <th>Drawer Options</th>
                    <th>Finish Front</th>
                    <th>Scoop</th>
                    <th>Include Glides</th>
                    <th>Gross</th>
                    <th>Net Cost</th>
                    <th>Net Profit</th>
                </tr>
                </thead>
                <tbody>
                {drawers.map((drawer, index) => {
                    // Determine if depth ends with '1/2'
                    const depthStr = drawer.depth ? drawer.depth.toString() : '';
                    const computedDrawerOptionsValue = depthStr.endsWith('1/2') ? 'Q' : (drawer.drawerOptions || '');
                    const computedFinishFrontValue = depthStr.endsWith('1/2') ? 'Yes' : 'No';

                    return (
                        <tr key={index}>
                            <td>{drawer.quantity}</td>
                            <td>{drawer.width}</td>
                            <td>{drawer.height}</td>
                            <td>{drawer.depth}</td>
                            <td>{drawer.bottom || '1/4"'}</td>
                            <td>
                                <Form.Select
                                    value={drawer.notchAndBore || 'Yes'}
                                    onChange={(e) => handleDrawerFieldChange(index, 'notchAndBore', e.target.value)}
                                >
                                    {yesNoOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </td>
                            <td>
                                <Form.Select
                                    value={drawer.finish || 'Yes'}
                                    onChange={(e) => handleDrawerFieldChange(index, 'finish', e.target.value)}
                                >
                                    {yesNoOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </td>
                            <td>
                                <Form.Select
                                    value={computedDrawerOptionsValue}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        handleDrawerFieldChange(index, 'drawerOptions', selectedValue);
                                    }}
                                >
                                    <option value="">Select</option>
                                    {drawerOptionsList.map((option, idx) => {
                                        // Get the prefix value (e.g., "Q" from "Q - Front Lip")
                                        const value = option.split('-')[0].trim();
                                        return (
                                            <option key={idx} value={value}>
                                                {option}
                                            </option>
                                        );
                                    })}
                                </Form.Select>
                            </td>
                            <td>
                                <Form.Select
                                    value={computedFinishFrontValue}
                                    onChange={(e) => handleDrawerFieldChange(index, 'finishFront', e.target.value)}
                                >
                                    {yesNoOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </td>
                            <td>
                                <Form.Select
                                    value={drawer.scoop || 'No'}
                                    onChange={(e) => handleDrawerFieldChange(index, 'scoop', e.target.value)}
                                >
                                    {yesNoOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </td>
                            <td>
                                <Form.Select
                                    value={'Blum Tandem'}
                                    onChange={(e) => handleDrawerFieldChange(index, 'includeGlides', e.target.value)}
                                >
                                    <option value="Blum Tandem" key="Blum Tandem">Blum Tandem</option>
                                    {/*{yesNoOptions.map((option) => (*/}
                                    {/*    <option key={option.value} value={option.value}>*/}
                                    {/*        {option.label}*/}
                                    {/*    </option>*/}
                                    {/*))}*/}
                                </Form.Select>
                            </td>
                            <td>{`$${drawer.totalPrice}` || ''}</td>
                            <td>{`$${drawer.netCost.toFixed(2)}` || ''}</td>
                            <td>{`$${drawer.netProfit.toFixed(2)}` || ''}</td>
                        </tr>
                    );
                })}
                </tbody>
            </Table>
        </div>
    );
};

export default DrawersTable;
